const finalTrial = {
  typeInfo: "noQuestions",
  title: "¡Encaje perfecto para clases online! 🎉",
  subtitle:
    "Parece que a tu hijo/a le puede encajar el formato de clases con profesor: tienen la posibilidad técnica, un interés claro en las clases regulares y condiciones adecuadas para empezar. ¡Prueben comenzar con la primera clase gratuita!",
  button: "Probar gratis 🚀",
  nextStep: 18,
};

const coldTitle = "Empecemos con una recomendación clara 🎯";
const coldSubtitle =
  "Ahora es mejor empezar con una recomendación clara: qué habilidades pueden encajarle al niño/a, qué proyectos podrá crear y qué formato de aprendizaje será cómodo.";

const finalPaid = {
  typeInfo: "noQuestions",
  title: coldTitle,
  subtitle: coldSubtitle,
  button: "Curso gratuito de 3 días",
  buttonEvent: "scoringfreecourse_button",
  redirectUrl: "https://rsa.kodland.org/es/onepager/free-mini-course",
};

export default {
  newDesign: true,
  parameters: {
    landing_id: "GRLaQv48",
    segment: 14,
  },
  title:
    "Encuentra el formato de aprendizaje adecuado para tu hijo/a | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  startPage: {
    title:
      "Responde estas 5 preguntas y recibe una clase gratuita para tu hijo/a",
    subtitle:
      "Tu hijo/a aprenderá programación y creará videojuegos y animaciones.",
    image: {
      url: "/welcome/fwd_latam_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/fwd_latam_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Presiona para continuar 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Si las clases resultan útiles para el niño/la niña, ¿estarían dispuestos a considerar clases regulares?",
      answers: [
        {
          answer: "Sí, ya estamos considerando esa posibilidad.",
          nextStep: 2,
        },
        {
          answer: "Sí, si el precio es razonable.",
          nextStep: 6,
        },
        {
          answer: "Aún no estamos seguros, necesitamos más información.",
          nextStep: 10,
        },
        {
          answer:
            "No, no planeamos pagar, incluso si al niño/la niña le gusta.",
          nextStep: 17,
        },
      ],
    },

    2: {
      question: "¿Tienen en casa una computadora o laptop para las clases?",
      answers: [
        { answer: "Sí, tenemos una computadora o laptop.", nextStep: 3 },
        {
          answer: "Por ahora, solo tenemos teléfono o tablet.",
          nextStep: 17,
        },
      ],
    },
    3: {
      question: "¿Qué tan estable es la conexión a internet en casa?",
      answers: [
        { answer: "Estable, normalmente sin problemas.", nextStep: 4 },
        { answer: "A veces se interrumpe.", nextStep: 8 },
        { answer: "Se interrumpe con frecuencia.", nextStep: 17 },
      ],
    },
    4: {
      question:
        "¿Qué presupuesto mensual para el desarrollo del niño/la niña consideran cómodo?",
      financial: true,
      answers: [
        { answer: "Hasta 30 USD.", nextStep: 9 },
        { answer: "30–60 USD.", nextStep: 5 },
        { answer: "60–100 USD.", nextStep: 5 },
        { answer: "Más de 100 USD.", nextStep: 13 },
      ],
    },
    5: {
      question: "¿El niño/la niña ya tuvo experiencia con clases online?",
      answers: [
        { answer: "No, todavía no.", nextStep: 14 },
        { answer: "Sí, una vez o por poco tiempo.", nextStep: 14 },
        { answer: "Sí, toma clases online con regularidad.", nextStep: 14 },
      ],
    },

    6: {
      question: "¿Tienen en casa una computadora o laptop para las clases?",
      answers: [
        { answer: "Sí, tenemos una computadora o laptop.", nextStep: 7 },
        {
          answer: "Por ahora, solo tenemos teléfono o tablet.",
          nextStep: 17,
        },
      ],
    },
    7: {
      question: "¿Qué tan estable es la conexión a internet en casa?",
      answers: [
        { answer: "Estable, normalmente sin problemas.", nextStep: 8 },
        { answer: "A veces se interrumpe.", nextStep: 8 },
        { answer: "Se interrumpe con frecuencia.", nextStep: 17 },
      ],
    },
    8: {
      question:
        "¿Qué presupuesto mensual para el desarrollo del niño/la niña consideran cómodo?",
      financial: true,
      answers: [
        { answer: "Hasta 30 USD.", nextStep: 13 },
        { answer: "30–60 USD.", nextStep: 9 },
        { answer: "60–100 USD.", nextStep: 9 },
        { answer: "Más de 100 USD.", nextStep: 13 },
      ],
    },
    9: {
      question: "¿El niño/la niña ya tuvo experiencia con clases online?",
      answers: [
        { answer: "No, todavía no.", nextStep: 15 },
        { answer: "Sí, una vez o por poco tiempo.", nextStep: 15 },
        { answer: "Sí, toma clases online con regularidad.", nextStep: 15 },
      ],
    },

    10: {
      question: "¿Tienen en casa una computadora o laptop para las clases?",
      answers: [
        { answer: "Sí, tenemos una computadora o laptop.", nextStep: 11 },
        {
          answer: "Por ahora, solo tenemos teléfono o tablet.",
          nextStep: 17,
        },
      ],
    },
    11: {
      question: "¿Qué tan estable es la conexión a internet en casa?",
      answers: [
        { answer: "Estable, normalmente sin problemas.", nextStep: 12 },
        { answer: "A veces se interrumpe.", nextStep: 12 },
        { answer: "Se interrumpe con frecuencia.", nextStep: 17 },
      ],
    },
    12: {
      question:
        "¿Qué presupuesto mensual para el desarrollo del niño/la niña consideran cómodo?",
      financial: true,
      answers: [
        { answer: "Hasta 30 USD.", nextStep: 13 },
        { answer: "30–60 USD.", nextStep: 13 },
        { answer: "60–100 USD.", nextStep: 13 },
        { answer: "Más de 100 USD.", nextStep: 13 },
      ],
    },
    13: {
      question: "¿El niño/la niña ya tuvo experiencia con clases online?",
      answers: [
        { answer: "No, todavía no.", nextStep: 14 },
        { answer: "Sí, una vez o por poco tiempo.", nextStep: 14 },
        { answer: "Sí, toma clases online con regularidad.", nextStep: 14 },
      ],
    },

    14: finalTrial,
    15: finalTrial,
    17: finalPaid,

    18: {
      title: "¿Qué edad tiene tu hijo/a?",
      subtitle: "Elegiremos el curso que mejor se adapte a la edad de tu hijo/a.",
      type: "age",
      button: "",
    },
    19: {
      title: "Reserva una clase gratuita",
      type: "one-page-contacts",
      subtitle:
        "Conozcámonos, veamos qué aprenderemos y cómo se desarrolla la clase.",
      button: "Casi terminamos 🔥",
    },
    20: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    21: {
      title: "Recordatorio rápido antes de la clase de prueba ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Por favor, conéctate a la clase desde una computadora o laptop y acompaña a tu hijo/a durante toda la lección. La clase de prueba es individual y personalizada.",
      button: "¿Qué más?",
    },
    22: {
      title:
        "Mantendremos contacto por correo y WhatsApp antes de tu clase. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Enviaremos un recordatorio 24 horas antes de la clase y te pediremos confirmar 2 horas antes. Estar en contacto nos ayuda a asegurar que la clase se realice según lo planeado.",
      button: "¿Qué más?",
    },
    23: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
